import { without } from 'lodash';
import { REMOVE_ALERT, SET_NEW_ALERT } from '../constants';

const initialState = [];

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_NEW_ALERT:
      return [...state, action.payload];
    case REMOVE_ALERT:
      return without(state, action.payload);
    default:
      return state;
  }
};
